import { useAppSelector } from '../../hooks/useReduxHelper';
import { selectLinkTarget } from '../../slices/WebView/WebViewSlice';

const useLinkTarget = () => {
  return useAppSelector(selectLinkTarget);
};

export default useLinkTarget;
